/* eslint-disable react/prop-types */
import React from 'react';
import EditableInputRGBA from './EditableInputRGB';
import { color as handleColor, hsvaToHsla, hslaToHsva } from './ColorUtils';

const EditableInputHSL = React.forwardRef((props, ref) => {
  const {
    prefixCls = 'saws-editable-input-hsl',
    hsva,
    hProps = {},
    sProps = {},
    lProps = {},
    className,
    onChange,
    ...other
  } = props;

  //lets us disable aprops for hsl
  const aProps = props.aProps ? props.aProps : {};

  const hsla = hsva ? hsvaToHsla(hsva) : { h: 0, s: 0, l: 0, a: 0 };

  /* eslint-disable-next-line no-unused-vars */
  const handleChange = (value, type, evn) => {
    if (typeof value === 'number') {
      if (type === 'h') {
        if (value < 0) value = 0;
        if (value > 360) value = 360;
        onChange && onChange(handleColor(hslaToHsva({ ...hsla, h: value })));
      }
      if (type === 's') {
        if (value < 0) value = 0;
        if (value > 100) value = 100;
        onChange && onChange(handleColor(hslaToHsva({ ...hsla, s: value })));
      }
      if (type === 'l') {
        if (value < 0) value = 0;
        if (value > 100) value = 100;
        onChange && onChange(handleColor(hslaToHsva({ ...hsla, l: value })));
      }
      if (type === 'a') {
        if (value < 0) value = 0;
        if (value > 1) value = 1;
        onChange && onChange(handleColor(hslaToHsva({ ...hsla, a: value })));
      }
    }
  };

  return (
    <EditableInputRGBA
      ref={ref}
      hsva={hsva}
      rProps={{
        label: 'H',
        value: Math.round(hsla.h),
        ...hProps,
        onChange: (evn, val) => handleChange(val, 'h', evn),
      }}
      gProps={{
        label: 'S',
        value: `${Math.round(hsla.s)}%`,
        ...sProps,
        onChange: (evn, val) => handleChange(val, 's', evn),
      }}
      bProps={{
        label: 'L',
        value: `${Math.round(hsla.l)}%`,
        ...lProps,
        onChange: (evn, val) => handleChange(val, 'l', evn),
      }}
      aProps={
        aProps
          ? aProps
          : {
              label: 'A',
              value: Math.round(hsla.a * 100) / 100,
              ...aProps,
              onChange: (evn, val) => handleChange(val, 'a', evn),
            }
      }
      className={[prefixCls, className || ''].filter(Boolean).join(' ')}
      {...other}
    />
  );
});

EditableInputHSL.displayName = 'EditableInputHSL';

export default EditableInputHSL;
